import { Link, NavLink } from "react-router-dom";
import { useAuthCheck } from "./components/Auth";
import { useEffect, useState, useRef } from "react";
import NoticeModal from "./components/NoticeModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes, faDoorOpen, faFileLines } from "@fortawesome/free-solid-svg-icons";
import logo from "./assets/images/VALCARDS.png";

const Header = () => {
    const { checkToken } = useAuthCheck();

    useEffect(() => {
        checkToken();
    }, [checkToken]);

    // Mode sombre
    const [darkMode, setDarkMode] = useState(localStorage.getItem("theme") === "dark");
    const [noticeOpen, setNoticeOpen] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    // Sous-menus (desktop + mobile)
    const [showProducts, setShowProducts] = useState(false);
    const [showUnity, setShowUnity] = useState(false);
    const [showProductSubmenu, setShowProductSubmenu] = useState(false);
    const [showUnitySubmenu, setShowUnitySubmenu] = useState(false);

    const closeTimeoutRef = useRef(null);
    const unityCloseTimeoutRef = useRef(null);

    useEffect(() => {
        if (darkMode) {
            document.documentElement.classList.add("dark");
            localStorage.setItem("theme", "dark");
        } else {
            document.documentElement.classList.remove("dark");
            localStorage.setItem("theme", "light");
        }
    }, [darkMode]);

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        window.location.href = "/";
    };

    const token = localStorage.getItem("token");
    if (!token) {
        return <div className="text-center pt-20 dark:bg-gray-800"></div>;
    }

    // --- Helpers pour Produits ---
    const openProducts = () => {
        if (closeTimeoutRef.current) clearTimeout(closeTimeoutRef.current);
        setShowProducts(true);
    };
    const scheduleCloseProducts = () => {
        if (closeTimeoutRef.current) clearTimeout(closeTimeoutRef.current);
        closeTimeoutRef.current = setTimeout(() => setShowProducts(false), 150);
    };
    const cancelScheduledClose = () => {
        if (closeTimeoutRef.current) clearTimeout(closeTimeoutRef.current);
    };

    // --- Helpers pour Cartes et Boosters ---
    const openUnity = () => {
        if (unityCloseTimeoutRef.current) clearTimeout(unityCloseTimeoutRef.current);
        setShowUnity(true);
    };
    const scheduleCloseUnity = () => {
        if (unityCloseTimeoutRef.current) clearTimeout(unityCloseTimeoutRef.current);
        unityCloseTimeoutRef.current = setTimeout(() => setShowUnity(false), 150);
    };
    const cancelScheduledUnityClose = () => {
        if (unityCloseTimeoutRef.current) clearTimeout(unityCloseTimeoutRef.current);
    };

    return (
        <>
            <header className="bg-gray-800 text-white dark:bg-gray-900 shadow-md">
                <div className="container mx-auto flex items-center justify-between p-4">
                    {/* Logo */}
                    <Link
                        to="/"
                        className="text-xl font-bold hover:text-yellow-400 flex items-center space-x-2"
                    >
                        <img src={logo} alt="Logo ValCard" className="w-20 rounded-lg" />
                        <span>Accueil</span>
                    </Link>

                    {/* Menu Desktop */}
                    <nav className="hidden lg:flex space-x-2 items-center">

                        {/* --- PRODUITS --- */}
                        <div
                            className="relative"
                            onMouseEnter={openProducts}
                            onMouseLeave={scheduleCloseProducts}
                        >
                            <button
                                onFocus={openProducts}
                                onBlur={scheduleCloseProducts}
                                aria-haspopup="true"
                                aria-expanded={showProducts}
                                className="px-3 py-2 rounded text-center transition hover:bg-gray-700 dark:hover:bg-gray-700"
                            >
                                Produits
                            </button>

                            <div
                                className={`absolute right-0 mt-1 w-56 z-50 rounded shadow-lg bg-gray-800 dark:bg-gray-900 transition-opacity duration-150
                                    ${showProducts ? "block opacity-100" : "hidden opacity-0"}`}
                                onMouseEnter={cancelScheduledClose}
                                onMouseLeave={scheduleCloseProducts}
                            >
                                <NavLink
                                    to="/add-product"
                                    className={({ isActive }) =>
                                        `block px-4 py-2 rounded transition ${isActive
                                            ? "bg-yellow-500 text-black"
                                            : "hover:bg-gray-700 dark:hover:bg-gray-700"
                                        }`
                                    }
                                >
                                    Ajouter un produit
                                </NavLink>
                                <NavLink
                                    to="/all-list"
                                    className={({ isActive }) =>
                                        `block px-4 py-2 rounded transition ${isActive
                                            ? "bg-yellow-500 text-black"
                                            : "hover:bg-gray-700 dark:hover:bg-gray-700"
                                        }`
                                    }
                                >
                                    Liste des produits
                                </NavLink>
                                <NavLink
                                    to="/sold-list"
                                    className={({ isActive }) =>
                                        `block px-4 py-2 rounded transition ${isActive
                                            ? "bg-yellow-500 text-black"
                                            : "hover:bg-gray-700 dark:hover:bg-gray-700"
                                        }`
                                    }
                                >
                                    Produits vendus
                                </NavLink>
                            </div>
                        </div>

                        {/* --- CARTES ET BOOSTERS --- */}
                        <div
                            className="relative"
                            onMouseEnter={openUnity}
                            onMouseLeave={scheduleCloseUnity}
                        >
                            <button
                                onFocus={openUnity}
                                onBlur={scheduleCloseUnity}
                                aria-haspopup="true"
                                aria-expanded={showUnity}
                                className="px-3 py-2 rounded text-center transition hover:bg-gray-700 dark:hover:bg-gray-700"
                            >
                                Cartes et Boosters
                            </button>

                            <div
                                className={`absolute left-0 mt-1 w-64 z-50 rounded shadow-lg bg-gray-800 dark:bg-gray-900 transition-opacity duration-150
                                    ${showUnity ? "block opacity-100" : "hidden opacity-0"}`}
                                onMouseEnter={cancelScheduledUnityClose}
                                onMouseLeave={scheduleCloseUnity}
                            >
                                <NavLink
                                    to="/add-unity_card"
                                    className={({ isActive }) =>
                                        `block px-4 py-2 rounded transition text-white ${isActive
                                            ? "bg-yellow-500 text-black"
                                            : "hover:bg-gray-700 dark:hover:bg-gray-700"
                                        }`
                                    }
                                >
                                    Ajouter une Carte et Booster
                                </NavLink>
                                <NavLink
                                    to="/unity_card-list"
                                    className={({ isActive }) =>
                                        `block px-4 py-2 rounded transition text-white ${isActive
                                            ? "bg-yellow-500 text-black"
                                            : "hover:bg-gray-700 dark:hover:bg-gray-700"
                                        }`
                                    }
                                >
                                    Liste des Cartes et Boosters
                                </NavLink>
                                <NavLink
                                    to="/sold-unity_card"
                                    className={({ isActive }) =>
                                        `block px-4 py-2 rounded transition text-white ${isActive
                                            ? "bg-yellow-500 text-black"
                                            : "hover:bg-gray-700 dark:hover:bg-gray-700"
                                        }`
                                    }
                                >
                                    Cartes et Boosters Vendus
                                </NavLink>
                            </div>
                        </div>

                        {/* ADMIN */}
                        {localStorage.getItem("role") <= 2 && (
                            <NavLink
                                key="/admin"
                                to="/admin"
                                className={({ isActive }) =>
                                    `px-3 py-2 rounded text-center transition ${isActive
                                        ? "bg-yellow-500 text-black"
                                        : "hover:bg-gray-700 dark:hover:bg-gray-700"
                                    }`
                                }
                            >
                                ADMINISTRATION
                            </NavLink>
                        )}

                        {/* Déconnexion */}
                        <button
                            onClick={handleLogout}
                            className="ml-4 px-3 py-2 rounded border border-gray-400 dark:border-gray-600 text-sm hover:bg-gray-700 dark:hover:bg-gray-700"
                        >
                            <FontAwesomeIcon icon={faDoorOpen} /> Se déconnecter
                        </button>

                        {/* Mode sombre */}
                        <button
                            onClick={() => setDarkMode(!darkMode)}
                            className="ml-4 px-3 py-2 rounded border border-gray-400 dark:border-gray-600 text-sm hover:bg-gray-700 dark:hover:bg-gray-700"
                        >
                            {darkMode ? "☀️" : "🌙"}
                        </button>

                        {/* Bouton Notice */}
                        <button
                            onClick={() => setNoticeOpen(true)}
                            className="hover:bg-gray-700 dark:hover:bg-gray-700 relative group ml-2"
                        >
                            <FontAwesomeIcon icon={faFileLines} />
                            <span className="absolute -top-7 left-1/2 -translate-x-1/2 text-xs bg-black text-white rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition">
                                Notice
                            </span>
                        </button>
                    </nav>

                    {/* Burger menu (mobile) */}
                    <button
                        className="lg:hidden text-2xl"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
                    </button>
                </div>

                {/* Menu Mobile */}
                {menuOpen && (
                    <div className="lg:hidden bg-gray-800 dark:bg-gray-900 px-4 pb-4 space-y-2">
                        {/* PRODUITS (mobile) */}
                        <div className="border border-gray-700 rounded">
                            <button
                                onClick={() => setShowProductSubmenu((prev) => !prev)}
                                className="w-full text-left px-3 py-2 rounded hover:bg-gray-700 dark:hover:bg-gray-700"
                            >
                                Produits
                            </button>
                            {showProductSubmenu && (
                                <div className="pl-4 space-y-1 mt-1">
                                    <NavLink
                                        to="/add-product"
                                        onClick={() => { setMenuOpen(false); setShowProductSubmenu(false); }}
                                        className={({ isActive }) =>
                                            `block px-3 py-2 rounded transition ${isActive
                                                ? "bg-yellow-500 text-black"
                                                : "hover:bg-gray-700 dark:hover:bg-gray-700"
                                            }`
                                        }
                                    >
                                        Ajouter un produit
                                    </NavLink>
                                    <NavLink
                                        to="/all-list"
                                        onClick={() => { setMenuOpen(false); setShowProductSubmenu(false); }}
                                        className={({ isActive }) =>
                                            `block px-3 py-2 rounded transition ${isActive
                                                ? "bg-yellow-500 text-black"
                                                : "hover:bg-gray-700 dark:hover:bg-gray-700"
                                            }`
                                        }
                                    >
                                        Liste des produits
                                    </NavLink>
                                    <NavLink
                                        to="/sold-list"
                                        onClick={() => { setMenuOpen(false); setShowProductSubmenu(false); }}
                                        className={({ isActive }) =>
                                            `block px-3 py-2 rounded transition ${isActive
                                                ? "bg-yellow-500 text-black"
                                                : "hover:bg-gray-700 dark:hover:bg-gray-700"
                                            }`
                                        }
                                    >
                                        Produits vendus
                                    </NavLink>
                                </div>
                            )}
                        </div>

                        {/* CARTES ET BOOSTERS (mobile) */}
                        <div className="border border-gray-700 rounded">
                            <button
                                onClick={() => setShowUnitySubmenu((prev) => !prev)}
                                className="w-full text-left px-3 py-2 rounded hover:bg-gray-700 dark:hover:bg-gray-700"
                            >
                                Cartes et Boosters
                            </button>
                            {showUnitySubmenu && (
                                <div className="pl-4 space-y-1 mt-1">
                                    <NavLink
                                        to="/add-unity_card"
                                        onClick={() => { setMenuOpen(false); setShowUnitySubmenu(false); }}
                                        className={({ isActive }) =>
                                            `block px-3 py-2 rounded transition text-white ${isActive
                                                ? "bg-blue-400 text-black"
                                                : "hover:bg-blue-500"
                                            }`
                                        }
                                    >
                                        Ajouter une Carte et Booster
                                    </NavLink>
                                    <NavLink
                                        to="/unity_card-list"
                                        onClick={() => { setMenuOpen(false); setShowUnitySubmenu(false); }}
                                        className={({ isActive }) =>
                                            `block px-3 py-2 rounded transition text-white ${isActive
                                                ? "bg-teal-400 text-black"
                                                : "hover:bg-teal-500"
                                            }`
                                        }
                                    >
                                        Liste des Cartes et Boosters
                                    </NavLink>
                                    <NavLink
                                        to="/sold-unity_card"
                                        onClick={() => { setMenuOpen(false); setShowUnitySubmenu(false); }}
                                        className={({ isActive }) =>
                                            `block px-3 py-2 rounded transition text-white ${isActive
                                                ? "bg-red-400 text-black"
                                                : "hover:bg-red-500"
                                            }`
                                        }
                                    >
                                        Cartes et Boosters Vendus
                                    </NavLink>
                                </div>
                            )}
                        </div>

                        {localStorage.getItem("role") && localStorage.getItem("role") <= 2 && (
                            <NavLink
                                key="/admin"
                                to="/admin"
                                onClick={() => setMenuOpen(false)}
                                className={({ isActive }) =>
                                    `block px-3 py-2 rounded transition ${isActive
                                        ? "bg-yellow-500 text-black"
                                        : "hover:bg-gray-700 dark:hover:bg-gray-700"
                                    }`
                                }
                            >
                                ADMINISTRATION
                            </NavLink>
                        )}

                        <button
                            onClick={() => {
                                handleLogout();
                                setMenuOpen(false);
                            }}
                            className="w-full text-left px-3 py-2 rounded border border-gray-400 dark:border-gray-600 text-sm hover:bg-gray-700 dark:hover:bg-gray-700"
                        >
                            <FontAwesomeIcon icon={faDoorOpen} /> Se déconnecter
                        </button>

                        {/* Notice */}
                        <button
                            onClick={() => {
                                setNoticeOpen(true);
                                setMenuOpen(false);
                            }}
                            className="w-full text-left px-3 py-2 rounded border border-gray-400 dark:border-gray-600 text-sm hover:bg-gray-700 dark:hover:bg-gray-700"
                        >
                            <FontAwesomeIcon icon={faFileLines} /> Notice
                        </button>

                        {/* Mode sombre */}
                        <button
                            onClick={() => {
                                setDarkMode(!darkMode);
                                setMenuOpen(false);
                            }}
                            className="w-full text-left px-3 py-2 rounded border border-gray-400 dark:border-gray-600 text-sm hover:bg-gray-700 dark:hover:bg-gray-700"
                        >
                            {darkMode ? "☀️ Mode clair" : "🌙 Mode sombre"}
                        </button>
                    </div>
                )}
            </header>

            <NoticeModal open={noticeOpen} onClose={() => setNoticeOpen(false)} />
        </>
    );
};

export default Header;
